import { render } from "./SelectObjectView.vue?vue&type=template&id=5a1fd1c2&scoped=true"
import script from "./SelectObjectView.vue?vue&type=script&lang=js"
export * from "./SelectObjectView.vue?vue&type=script&lang=js"

import "./SelectObjectView.vue?vue&type=style&index=0&id=5a1fd1c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a1fd1c2"

export default script